import { type IBuyerMemberQuery } from 'application/querySchemas/IBuyerMemberQuery';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IBuyerMemberListClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/IBuyerMemberListClient';
import {
    type IBuyerUserClient,
    IGetResponse as IBuyerUserResponse,
} from 'interfaceAdapter/gatewaySchemas/IBuyerUserClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class BuyerMemberQuery implements IBuyerMemberQuery {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerMemberListClient')
        public readonly buyerMemberListClient: IBuyerMemberListClient,
        @inject('IBuyerUserClient')
        public readonly buyerUserClient: IBuyerUserClient,
    ) {}

    public async fetchList(): Promise<IGetResponse['data']> {
        const { data, message } = await this.buyerMemberListClient.get({
            token: this.buyerUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }

    public async fetchUser(userId: number): Promise<IBuyerUserResponse['data']> {
        const { data, message } = await this.buyerUserClient.get({
            token: this.buyerUserToken.get() || '',
            userId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
